import { Trophy, Star, Handshake, Globe, Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import SectionHeading from "./SectionHeading";
import { EVENTOS, DEPOIMENTOS, VIDEO_TREINO } from "../data/siteData";

const ICONES = { Trophy, Star, Handshake, Globe };

const Eventos = () => (
  <section id="eventos" data-testid="eventos-section" className="gold-specks relative bg-night py-20 md:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="História em campo"
        title="Eventos e Conquistas"
        lead="Torneios próprios, peneiras com clubes profissionais e experiências internacionais para os nossos atletas."
      />

      <div className="relative mx-auto max-w-3xl pl-16 sm:pl-0">
        <div className="absolute bottom-0 left-6 top-0 w-px -translate-x-1/2 bg-gradient-to-b from-gold/60 via-lawn/40 to-transparent sm:left-1/2" aria-hidden="true" />
        {EVENTOS.map((ev, i) => {
          const Icon = ICONES[ev.icone];
          const esquerda = i % 2 === 0;
          return (
            <Reveal key={ev.titulo} delay={0.05} className="relative mb-10 last:mb-0">
              <div
                data-testid={`evento-item-${i}`}
                className={`relative sm:w-1/2 ${esquerda ? "sm:pr-14" : "sm:ml-auto sm:pl-14"}`}
              >
                <span
                  className={`absolute -left-16 top-0 z-10 flex h-12 w-12 items-center justify-center rounded-full border-2 border-gold bg-night ${
                    esquerda ? "sm:-right-6 sm:left-auto" : "sm:-left-6"
                  }`}
                >
                  <Icon size={20} className="text-gold" strokeWidth={1.9} />
                </span>
                <div className={`rounded-2xl border border-white/10 bg-navy/70 p-5 transition-colors duration-300 hover:border-gold/40 ${esquerda ? "sm:text-right" : ""}`}>
                  <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-lawn">{ev.tag}</span>
                  <h3 className="mt-1 font-display text-2xl uppercase tracking-wide text-white">{ev.titulo}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/70">{ev.descricao}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal className="mt-16">
        <div
          data-testid="eventos-video"
          className="mx-auto max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-navy/60"
        >
          <div className="p-6 pb-0 text-center md:p-8 md:pb-0">
            <h3 className="font-display text-3xl uppercase tracking-wide text-white">
              Confira um treino da Soccer Trainer
            </h3>
            <p className="mt-2 text-sm text-white/60">Aperte o play e veja como trabalhamos em campo.</p>
          </div>
          <video
            src={VIDEO_TREINO}
            controls
            playsInline
            preload="metadata"
            data-testid="eventos-video-player"
            className="mt-6 aspect-video w-full bg-night object-contain"
          />
        </div>
      </Reveal>

      <div className="mt-24">
        <SectionHeading eyebrow="Quem vive a escola" title="Depoimentos de pais e atletas" />
        <div className="grid gap-6 md:grid-cols-3">
          {DEPOIMENTOS.map((d, i) => (
            <Reveal key={d.nome} delay={i * 0.1}>
              <figure
                data-testid={`depoimento-card-${i}`}
                className="flex h-full flex-col rounded-2xl border border-white/10 bg-navy/70 p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-gold/40"
              >
                <Quote size={28} className="mb-4 text-gold/70" />
                <div className="mb-4 flex gap-1" aria-label="Avaliação 5 de 5">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={15} className="fill-gold text-gold" />
                  ))}
                </div>
                <blockquote className="flex-1 text-sm leading-relaxed text-white/80">“{d.texto}”</blockquote>
                <figcaption className="mt-5">
                  <p className="font-heading text-sm font-semibold uppercase tracking-wide text-white">{d.nome}</p>
                  <p className="text-xs text-lawn">{d.relacao}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Eventos;
